import { GraphQLClient } from 'graphql-request'
import { DataProvider } from '@pankod/refine-core'
import { GetSocialMediasDocument, GetSocialMediaDocument } from '../../gql/graphql'
// import { UpdateSocialMediaInput } from 'gql/graphql'

export const SocialMediasDataProvider = (client: GraphQLClient): DataProvider =>
    ({
        getList: async ({ pagination, hasPagination }) => {
            const pageSize = pagination?.pageSize ?? 10
            const current = pagination?.current ?? 1
            const paging = hasPagination
                ? {
                      skip: (current - 1) * pageSize,
                      limit: pageSize,
                  }
                : {}
            const result = await client.request(GetSocialMediasDocument, { skip: paging.skip, limit: paging.limit })
            return {
                data: result.adminSocialMedias.items,
                total: result.adminSocialMedias.total,
            }
        },
        async getOne({ id }: { id: string }) {
            const result = await client.request(GetSocialMediaDocument, { id })
            return { data: result.adminSocialMedia }
        },
        // async update({ variables, id }: { variables: UpdateSocialMediaInput; id: string }) {
        //     const { name, icon, parentId } = variables
        //     const sortIndex = variables.sortIndex ? Number(variables.sortIndex) : variables.sortIndex
        //     const updateSocialMediaInput = {
        //         name: name,
        //         icon: icon,
        //         sortIndex: sortIndex,
        //         parentId: parentId,
        //     }

        //     const result = await client.request(UpdateSocialMediaDocument, { id, updateSocialMediaInput })
        //     return {
        //         data: result.adminSocialMediaUpdate,
        //     }
        // },
    } as DataProvider)
